<div class="row">
    <div class="col-md-12">
        <div class="card memberships">
            <div class="card-header">
                <h3 class="mb-0">{{"PROFILE.YOUR_MEMBERSHIPS" | translate}}</h3>
            </div>
            <div class="card-body">
                <!-- <div class="table-responsive">
                <table class="table table-bordered table-striped mb-0">
                    <thead>
                        <tr>
                            <th>{{"PROFILE.MEMBERSHIP_NUMBER" | translate}}</th>
                            <th>{{"PROFILE.FINAL_PRICE" | translate}}</th>
                            <th>{{"PROFILE.ACTIVATED_DATE" | translate}}</th>
                            <th>{{"PROFILE.EXPIRY_DATE" | translate}}</th>
                            <th>{{"PROFILE.STATUS" | translate}}</th>
                            <th>{{"PROFILE.ACTIONS" | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let membership of data">
                            <td>{{membership.membershipNumber}}</td>
                            <td>{{membership.finalPrice}}</td>
                            <td>{{ membership.activatedAt | date:'dd-MM-yyyy' }}</td>
                            <td>{{ membership.expiryDate | date:'dd-MM-yyyy' }}</td>
                            <td>{{membership.membershipStatus}}
                                @if(membership?.latestLogNote ){
                                <span class="info-icon">i
                                    <span class="tooltip-text">
                                        {{ membership.latestLogNote }}
                                    </span>
                                </span>
                                }

                            </td>
                            <td>
                                <div class="dropdown">
                                    <button class="btn btn-red btn-sm dropdown-toggle" type="button"
                                        id="actionsDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{"PROFILE.ACTIONS" | translate}}
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="actionsDropdown">
                                        <li
                                            *ngIf="membershipStatus === 'ApplicationApproved' || membershipStatus === 'PaymentRejected'">
                                            <a data-bs-toggle="modal" data-bs-target="#applyCoupon"
                                                class="dropdown-item">
                                                {{"MEMBERSHIP.APPLY_COUPON" |
                                                translate}}</a>
                                        </li>
                                        <li
                                            *ngIf="membershipStatus === 'ApplicationApproved' || membershipStatus === 'PaymentRejected'">
                                            <a data-bs-toggle="modal" data-bs-target="#UploadAttachments"
                                                class="dropdown-item">{{"MEMBERSHIP.ADD_BILL_IMAGES" | translate}}</a>
                                        </li>
                                        <li><a data-bs-toggle="modal" data-bs-target="#membershipDetails"
                                                class="dropdown-item">{{"MEMBERSHIP.MEMBERSHIP_DETAILS" |
                                                translate}}</a>
                                        </li>
                                        <li *ngIf="membershipStatus ==='Rejected'"><a data-bs-toggle="modal"
                                                data-bs-target="#applyMembership"
                                                class="dropdown-item">{{"MEMBERSHIP.EDIT_YOUR_MEMBERSHIP_DATA" |
                                                translate}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div> -->


                <div class="table-responsive">
                    <table class="table table-bordered table-striped mb-0">
                        <thead>
                            <tr>
                                <th>{{"PROFILE.MEMBERSHIP_NUMBER" | translate}}</th>
                                <th>{{"PROFILE.FINAL_PRICE" | translate}}</th>
                                <th>{{"PROFILE.ACTIVATED_DATE" | translate}}</th>
                                <th>{{"PROFILE.EXPIRY_DATE" | translate}}</th>
                                <th>{{"PROFILE.STATUS" | translate}}</th>
                                <th>{{"PROFILE.ACTIONS" | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (membership of data; track $index) {
                            <tr>
                                <td>{{membership.membershipNumber}}</td>
                                <td>{{membership.finalPrice}}</td>
                                <td>{{ membership.activatedAt | date:'dd-MM-yyyy' }}</td>
                                <td>{{ membership.expiryDate | date:'dd-MM-yyyy' }}</td>
                                <td>{{membership.membershipStatus}}
                                    @if(membership.latestLogNote){
                                    <div class="position-r">
                                        <span class="info-icon">
                                            <i class="fas fa-info"></i>
                                            <span class="tooltip-text">{{ membership.latestLogNote }}</span>
                                        </span>
                                    </div>
                                    }

                                </td>
                                <td>
                                    <div class="dropdown">
                                        <button class="btn btn-red btn-sm dropdown-toggle" type="button"
                                            id="actionsDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                            {{"PROFILE.ACTIONS" | translate}}
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="actionsDropdown">
                                            <li
                                                *ngIf="membershipStatus === 'ApplicationApproved' || membershipStatus === 'PaymentRejected'">
                                                <a data-bs-toggle="modal" data-bs-target="#applyCoupon"
                                                    class="dropdown-item">
                                                    {{"MEMBERSHIP.APPLY_COUPON" |
                                                    translate}}</a>
                                            </li>
                                            <li
                                                *ngIf="membershipStatus === 'ApplicationApproved' || membershipStatus === 'PaymentRejected'">
                                                <a data-bs-toggle="modal" data-bs-target="#UploadAttachments"
                                                    class="dropdown-item">{{"MEMBERSHIP.ADD_BILL_IMAGES" |
                                                    translate}}</a>
                                            </li>
                                            <li><a data-bs-toggle="modal" data-bs-target="#membershipDetails"
                                                    class="dropdown-item">{{"MEMBERSHIP.MEMBERSHIP_DETAILS" |
                                                    translate}}</a>
                                            </li>
                                            <li *ngIf="membershipStatus ==='Rejected'"><a data-bs-toggle="modal"
                                                    data-bs-target="#applyMembership"
                                                    class="dropdown-item">{{"MEMBERSHIP.EDIT_YOUR_MEMBERSHIP_DATA" |
                                                    translate}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="d-block mx-auto">
                @if(!isMember){
                <button *ngIf="membershipStatus === ''|| membershipStatus === undefined" class="btn btn-red my-5"
                    data-bs-toggle="modal" data-bs-target="#applyMembership">
                    {{"MEMBERSHIP.APPLYFORMEMBERSHIP"| translate}}
                </button>
                }

                @else if((isMember && membershipStatus ==="Expired") ||
                (membershipDataForUser&&membershipDataForUser?.isNearestExpired)){
                <button class="btn btn-red my-5" data-bs-toggle="modal" data-bs-target="#applyMembership">
                    {{"MEMBERSHIP.REAPPLYFORMEMBERSHIP"| translate}}
                </button>

                }
            </div>
        </div>

    </div>

    <app-apply-coupon [membershipData]="membershipData" [membershipId]="membershipId"
        (membershipDataUpdated)="updateMembershipData()"
        (getMembershipByUserId)="getMembershipByUserId()"></app-apply-coupon>
    <app-upload-bills [membershipData]="membershipData" [membershipId]="membershipId"
        (membershipDataUpdated)="updateMembershipData()"
        (getMembershipByUserId)="getMembershipByUserId()"></app-upload-bills>
    <app-membership-deatails [membershipData]="membershipData"></app-membership-deatails>
    <app-apply-for-membership [membershipDataForUser]="membershipDataForUser"
        (getMembershipByUserId)="getMembershipByUserId()"></app-apply-for-membership>